/*
 * Sends the connector's diagnostics to the bridge (POST /api/clientlog), so they appear in the
 * bridge's terminal. The connector runs in a hidden Salesforce iframe, where the browser console
 * is hard to reach.
 */
import { bridgeUrl, whenBridge } from './bridge-url';

// With the front door, the bridge is only known after the directory lookup: keep early lines until then.
const early = [];
whenBridge(() => early.splice(0).forEach(send));

function send(msg) {
    try {
        fetch(`${bridgeUrl()}/api/clientlog`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
                                                body: JSON.stringify({ msg }), keepalive: true }).catch(() => {});
    } catch (e) { /* logging must never break the connector */ }
}

function text(a) {
    if (a instanceof Error) return `${a.name}: ${a.message}`;
    if (typeof a === 'string') return a;
    try { return JSON.stringify(a); } catch (e) { return String(a); }
}

export function rlog(...args) {
    const msg = args.map(text).join(' ');
    console.log('[BroadWorks connector]', msg);
    if (bridgeUrl()) send(msg);
    else if (early.length < 50) early.push(msg);
}

window.addEventListener('error', (e) => rlog('window error:', e.message, `${e.filename || ''}:${e.lineno || ''}`));
window.addEventListener('unhandledrejection', (e) => rlog('unhandled rejection:', e.reason));
// Salesforce starts the connector with a SETUP_CONNECTOR window message; show what arrives and from where.
window.addEventListener('message', (e) => {
    const type = e.data && e.data.type;
    if (type) rlog(`message ${type} from ${e.origin}`);
});
